export var UserLanguageKey;
(function (UserLanguageKey) {
    UserLanguageKey["Language"] = "UserLanguage.Language";
    UserLanguageKey["Date"] = "UserLanguage.Date";
})(UserLanguageKey || (UserLanguageKey = {}));
export var UserThemeKey;
(function (UserThemeKey) {
    UserThemeKey["Theme"] = "UserTheme.Theme";
})(UserThemeKey || (UserThemeKey = {}));
